import React from "react";
import { ReceiptText } from "lucide-react";
import HRISListPage from "../../../HRISListPage";
import {
  getExpenseClaimTypes,
  createExpenseClaimType,
  updateExpenseClaimType,
  deleteExpenseClaimType,
} from "../../../hrisApi";

import "../../../hrisDummyData"; // Auto-initializes dummy data on load

const columns = [
  { key: "code", label: "Code" },
  { key: "name", label: "Type Name" },
  { key: "description", label: "Description" },
  { key: "status", label: "Status", badge: true },
];

const formFields = [
  {
    key: "code",
    label: "Code",
    type: "text",
    required: true,
    placeholder: "e.g. TRAVEL",
  },
  {
    key: "name",
    label: "Type Name",
    type: "text",
    required: true,
    placeholder: "e.g. Travel",
  },
  {
    key: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Optional details...",
  },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: ["Active", "Inactive"],
    defaultValue: "Active",
  },
];

const ExpenseClaimTypes = () => (
  <HRISListPage
    title="Expense Claim Types"
    description="Manage HRIS expense claim categories and types."
    icon={<ReceiptText />}
    columns={columns}
    fetchData={getExpenseClaimTypes}
    createData={createExpenseClaimType}
    updateData={updateExpenseClaimType}
    deleteData={deleteExpenseClaimType}
    formFields={formFields}
    entityName="Expense Claim Type"
    searchPlaceholder="Search by code or name..."
  />
);

export default ExpenseClaimTypes;
